import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/toPromise';


import * as _ from 'lodash';

import { Http, Response, Headers, ResponseContentType } from '@angular/http';

import { Auth } from './auth.service';
import { AppConfig } from '../app.config';

import { SpinnerService } from '../spinner.service';
import { LoginAttempt } from '../classes/loginAttempt';

@Injectable()
export class RequestService {

  private baseUrl: string;
  private headers: Headers;
  private serverUrls: any = {
    admins: '/admin',
    admin: '/admin/{id}',
    affiliatesPerProvince: '/reports/affiliatesPerProvince',
    affiliatesPerOffice: '/reports/affiliatesPerOffice',
    affiliatesPerPlan: '/reports/affiliatesPerPlan',
    appsInfo: '/appInfo',
    appInfo: '/appInfo/{id}',
    billingCallsReport: '/reports/billing',
    loginsReport: '/reports/logins',
    calls: '/calls',
    call: '/call/{id}',
    callsPerProvince: '/reports/callsPerProvince',
    callsPerOffice: '/reports/callsPerOffice',
    checkIfPatientExistsInWebService: '/provider/{id}/checkIfPatientExistsInWebService/{documentNumber}/{validator}',
    createCall: '/call',
    sendMedicalCareRecord: '/call/medicalCareRecord',
    sendDoctorToPrescribe: '/call/sendDoctorToPrescribe',
    createPatient:'/patient/createAffiliate',
    developers: '/developer',
    developer: '/developer/{id}',
    deleteFarmalinkPrescription: '/farmalink/delete',
    resendFarmalinkPrescription: '/farmalink/resend',
    doctors: '/doctor',
    doctor: '/doctor/{id}',
    doctorActivate: '/doctor/{id}/activate',
    doctorDeactivate: '/doctor/{id}/deactivate',
    doctorCalls: '/doctor/{id}/calls',
    doctorProvider:'/provider/{id}/doctors',
    doctorProviderEdit:'/provider/{id}/doctor/{doctorId}',
    doctorAddToAllProviders:'/doctor/{id}/AddToAllProvidersAndPriorities',
    doctorRemoveFromAllProviders:'/doctor/{id}/RemoveFromAllProvidersAndPriorities',
    addAllDoctors:'/provider/{id}/addAllDoctors',
    removeAllDoctors:'/provider/{id}/removeAllDoctors',
    defaultReports: '/reports/defaultReports',
    dashboardInfo: '/reports/dashboardInformation/{infoName}',
    doctorsWithPriority: '/withPriority/{provider}/{specialty}',
    doctorsWithoutPriority: '/withoutPriority/{provider}/{specialty}',
    family: '/familyGroup/{id}',
    forceNotBillable: "/call/{id}/setNotBillable",
    holidays: '/holiday',
    holiday: '/holiday/{id}',
    holidayProvider:'/provider/{id}/holidays',
    holidayProviderEdit:'/provider/{id}/holiday/{holiday}',
    loginAttempts: '/loginAttempt',
    loginAttempt: '/loginAttempt/{id}',
    logginAtemptReport: '/loginAttempt/download',
    me: '/me',
    migration: '/migration',
    moveProviderPriority:'/provider/movePriority',
    patients: '/patient',
    patient: '/patient/{id}',
    patientWithProviderAndValidationInfo: '/patient/{id}/withProviderAndValidationInfo',
    patientsTable: '/patient/table',
    patientsProviderDocumentNumber: '/patient/byProviderDocumentNumber/{provider}/{documentNumber}',
    patientActivate: '/patient/{id}/activate',
    patientDeactivate: '/patient/{id}/deactivate',
    patientInfo: '/test/userInfo?auth0Id=ps-sancor-dev|{auth0_user}',
    plans: '/plan',
    plan: '/plan/{id}',
    planProvider:'/provider/{id}/plans',
    planProviderEdit:'/provider/{id}/plan/{plan}',
    patientCalls: '/patient/{id}/calls',
    patientCreatedBySellerReport: '/patient/seller/report',
    patientsCreatedPerOffice: '/reports/patientsCreatedPerOffice',
    patientsCreatedPerProvince: '/reports/patientsCreatedPerProvince',
    patientsCreatedPerPlan: '/reports/patientsCreatedPerPlan',
    patientsCount:'/patient/count',
    parameters: '/extraParameter/',
    parameter: 'extraParameter/{id}',
    providers: '/provider',
    providerNames: '/provider/names',
    providersAll:'/provider/all',
    provider: '/provider/{id}?details=true',
    nativeUpdate: '/provider/{id}/nativeUpdate',
    providerUploadImage: '/provider/{id}/uploadImage',
    providerTC: '/provider/{id}/tc',
    TCProvider: '/termsAndConditions/provider/{id}',
    TCUpdate: '/termsAndConditions/{id}',
    TC: '/termsAndConditions',
    providerAffiliates: '/provider/{id}/update',
    providerAppointmentAttachments: '/provider/{id}/appointmentAttachments',
    providerAppointmentAttachmentsRemove: '/provider/{id}/removeAppointmentAttachments',
    providerDetails: '/provider/{id}/detail',
    providerServices: '/provider/services',
    providerVademecum: '/provider/{id}/vademecum',
    providerWithPriority: '/provider/withPriority',
    providerWithoutPriority: '/provider/withoutPriority',
    providerSatisfactionSurveyQuestions: '/provider/{id}/satisfactorySurveyQuestions',
    priorityItem: '/priorityItem/{id}',
    priorityOneUp:'/priority/moveOneUp',
    priorityOneDown:'/priority/moveOneDown',
    priorityTenUp:'/priority/moveTenUp',
    priorityTenDown:'/priority/moveTenDown',
    priorityFirst:'/priority/first',
    priorityLast:'/priority/last',
    priorityItemAll: '/priorityItem',
    pharmaciesPDF: '/pharmaciesList',
    languages: '/languages',
    removeProviderPriority: '/provider/removePriority',
    reportsProvider: '/provider/{id}/reports',
    reportProvider: '/provider/{id}/report/{idReport}',
    specialties: '/specialty',
    specialty: '/specialty/{id}',
    specialtyProvider:'/provider/{id}/specialties',
    specialtyProviderEdit:'/provider/{id}/specialty/{specialty}',
    updateAffiliatesData: '/patients/updateData',
    updateMedicines: '/medicines/vademecum/update',
    userFiles: '/user/{id}/files',
    sellers: '/seller',
    seller: '/seller/{id}',
    specialtyProviderConfigs: '/specialtyProviderConfig',
    specialtyProviderConfig: '/specialtyProviderConfig/{id}',
    specialtyProviderConfigByProvider: '/specialtyProviderConfig/provider/{id}',
    specialtyProviderConfigBySpecialty: '/specialtyProviderConfig/provider/{providerId}/specialty/{specialtyId}',
    healthInsurances: '/healthInsurances',
    healthInsurance: '/healthInsurance/{id}',
    callTags: '/callTags',
    callTag: '/callTag/{id}',
    callFiles: '/call/{id}/files',
    callLogs: '/call/{id}/logs',
    prescriptionsPdfs: '/call/{id}/prescriptionsPdfs',
    callStates: '/call/states',
    sendFilesByWhatsapp: '/call/{id}/sendFilesTemplate',
    updateLanguage:'/provider/{id}/language/{languageId}',
    updateDoctorLanguage: '/doctor/{id}/language/{languageId}',
    supportedLanguages:'/supportedLanguages',
    patientForValidation: '/patient?needsValidation=true',
    patientFailedValidation: '/patient?failedValidation=true',
    startValidating: '/patient/{id}/startValidating',
    stopValidating: '/patient/{id}/stopValidating',
    validatePatient: '/patient/{id}/validate',
    invalidatePatient: '/patient/{id}/invalidate',
    resetFailedValidation: '/patient/{id}/resetFailedValidation',
    startDischarging: '/patient/{id}/startDischarging',
    stopDischarging: '/patient/{id}/stopDischarging',
    administrativeDischargePatient: '/patient/{id}/discharge',
    resetWasDischarged: '/patient/{id}/resetWasDischarged',
    registerSubscriber:'/subscriber',
    invalidateCall: "/call/{id}/invalidateCall",
    validateCall: "/call/{id}/validateCall",
    doctorStatus: "/doctors/status",
    failedEmail: "/failedEmail",
    sendFailedEmail: "/failedEmail/send",
    stopMonitoring: "/patient/{id}/stopMonitoring",
    dischargePatient: "/patient/{id}/dischargePatient",
    saveMedikitData:"/doctor/{id}/saveMedikitData",
    setMedikitIds: "/specialty/setMedikitIds",
    sendReportToLadDoctors: "/reports/sendDoctorsBilling",
    sendCallReportEmail: "/call/report/{id}",
    sendPatientMedicalHistory: "/patient/{id}/history",
    setPatientBannedStatus: "/patient/{id}/setBannedStatus",
    setDoctorBannedStatus: "/doctor/{id}/setBannedStatus",
    changeDeveloperPassword: "/developer/{id}/changePassword",
    permissions: "/permissions"
  };

  constructor(private http: Http, private auth: Auth, private config: AppConfig, private spinner: SpinnerService) {

    this.headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + auth.getIdToken()
    });

    this.baseUrl = config.get('SERVER_URL');
  }

  private parseUrl(options: any) {

    let urlKey: string = options.urlKey;
    let url = this.baseUrl;
    if (_.has(this.serverUrls, urlKey)) {

      url += this.serverUrls[urlKey];
    }

    return this.finishParse(url, options)
  };

  setToken(){
    this.headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.auth.getIdToken()
    });
  }

  finishParse(url, options) {
    let urlParams: any = options.urlParams || {};
    let urlQueryParams: any = options.urlQueryParams || {};
    _.each(urlParams, function (value: any, key: string) {

      url = url.replace('{' + key + '}', value);
    });

    _.each(urlQueryParams, function (value: any, key: string) {

      url += (_.indexOf(url, '?') > 0 ? '&' : '?') + key + '=' + value;
    });

    return url;

  }

  private handleError(error: any): Promise<any> {

    //console.error('An error occurred', error); // for demo purposes only

    return Promise.reject(error.message || error);
  };

  makeRequest(requestData: any,endpoint:string=undefined): any {

    let options: any = {
      method: requestData.method || 'get',
      body: requestData.body,
      headers: this.headers,
      responseType: requestData.responseType || ResponseContentType.Json
    };

    if (!_.isUndefined(requestData.responseType))
      options.responseType = requestData.responseType

    this.spinner.start();

    let url;
    if (!endpoint) url = this.parseUrl(requestData);
    else{
      url = this.baseUrl+endpoint
      url = this.finishParse(url,requestData)
    }
    //console.log('url para request: ' +url);
    let reqObs = this.http.request(url, options).share()

    reqObs.subscribe(next => this.spinner.stop(),
      error => this.spinner.stop());

    if (requestData.asObservable) {

      return reqObs;
    }

    return reqObs.toPromise().catch(this.handleError);
  };

  makeRequestImage(requestData: any): any {
    this.spinner.start();
    var url = this.parseUrl(requestData);
    return this.finishRequestImage(requestData,url)

  }

  makeRequestImageWithEndpoint(requestData,endpoint){
    var url = this.finishParse(this.baseUrl+endpoint, requestData)
    return this.finishRequestImage(requestData,url)
  }

  finishRequestImage(requestData,url){
    var token = this.auth.getIdToken()
    var self = this
    return new Promise(function (resolve, reject) {
      let header = new Headers({
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + token
      });


      let xhr: XMLHttpRequest = new XMLHttpRequest();
      let formData = requestData.body;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            self.spinner.stop();
            resolve(xhr.response);

          } else {
            alert("TIMEOUT ERROR: Wasnt able to load correctly")
            self.spinner.stop();
            reject(xhr.response);
          }
        }
      };
      xhr.open('PUT', url, true);
      xhr.setRequestHeader('Authorization', 'Bearer ' + token);
      xhr.send(formData);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/request.service.ts